<template>
    <div
        v-if="visible"
        class="loading-overlay"
        role="status"
        aria-live="polite"
    >
        <span class="app-loading__spinner" aria-hidden="true"></span>
        <span class="app-loading__message">Loading...</span>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<!-- Shared loading styles are inline in public/index.html for pre-JS rendering. -->
